import React, { useEffect } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";
import site_logo from "../assets/site_logo.png";
import nav_user_icon from "../assets/nav-user-icon.png";
import { notifyIracingLinkChanged } from "../utils/driverPrivacy";
import "../styles/TopNav.css";

export const TopNav = ({ isLoggedIn, setIsLoggedIn }) => {
	let navigate = useNavigate();

	const checkLoginStatus = () => {
		const token = localStorage.getItem("token");
		setIsLoggedIn(!!token);
	};

	useEffect(() => {
		// Check login status when the component mounts
		checkLoginStatus();

		// Add an event listener for the storage event
		window.addEventListener("storage", checkLoginStatus);

		// Cleanup the event listener when the component unmounts
		return () => {
			window.removeEventListener("storage", checkLoginStatus);
		};
	}, []);

	const handleLogout = () => {
		localStorage.removeItem("token");
		localStorage.removeItem("username");
		localStorage.removeItem("isLoggedIn");
		localStorage.removeItem("isPaidUser");
		localStorage.removeItem("iracingLinked");
		localStorage.removeItem("iracingOnly");
		notifyIracingLinkChanged();
		setIsLoggedIn(false);
		navigate("/login");
	};

	return (
		<Navbar expand="lg" className="topnavcontainer" variant="dark">
			<div onClick={() => navigate("/")} className="topnavbrand">
				<img src={site_logo} alt="iRacing6 Logo" className="topnavlogo" />
			</div>
			<Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />

			<Navbar.Collapse id="basic-navbar-nav">
				<Nav className="mr-auto">
					<NavDropdown title="Drivers" id="nav-drivers">
						<LinkContainer to="/user/careerstats">
							<NavDropdown.Item>Career Stats</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/leaderboards">
							<NavDropdown.Item>Leaderboards</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/charts/irating">
							<NavDropdown.Item>iRating Distribution</NavDropdown.Item>
						</LinkContainer>
					</NavDropdown>
					<NavDropdown title="Races" id="nav-races">
						<LinkContainer to="/RaceResults/recent">
							<NavDropdown.Item>Recent Race Results</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/contests">
							<NavDropdown.Item>Contests</NavDropdown.Item>
						</LinkContainer>
					</NavDropdown>
					<NavDropdown title="Series" id="nav-series">
						<LinkContainer to="/charts/SeriesPopularity">
							<NavDropdown.Item>Series Popularity</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/charts/SeriesSafety">
							<NavDropdown.Item>Series Safety</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/charts/SeriesLapTimeChart/">
							<NavDropdown.Item>Series Lap Times</NavDropdown.Item>
						</LinkContainer>
					</NavDropdown>
					<LinkContainer to="/telemetry">
						<Nav.Link>Telemetry</Nav.Link>
					</LinkContainer>
					<LinkContainer to="/WorldRecords">
						<Nav.Link>World Records</Nav.Link>
					</LinkContainer>
					<LinkContainer to="/pro">
						<Nav.Link className="nav-pro-link">Pro Dashboard</Nav.Link>
					</LinkContainer>
				</Nav>
				<Nav className="ms-auto">
					<NavDropdown
						title={
							<span>
								<img
									src={nav_user_icon}
									alt="User menu"
									style={{ verticalAlign: "middle", marginRight: ".1rem", marginLeft: ".5rem", marginBottom: ".15rem", height: "0.9rem" }}
								/>
							</span>
						}
						id="nav-user"
						align="end"
					>
						{isLoggedIn ? (
							<>
								<LinkContainer to="/account">
									<NavDropdown.Item>Account</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/support">
									<NavDropdown.Item>Support The Site</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/about/PrivacyPolicy">
									<NavDropdown.Item>Privacy Policy</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/about/Contact">
									<NavDropdown.Item>Contact</NavDropdown.Item>
								</LinkContainer>
								<NavDropdown.Divider />
								<NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
							</>
						) : (
							<>
								<LinkContainer to="/login">
									<NavDropdown.Item>Login</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/register">
									<NavDropdown.Item>Register</NavDropdown.Item>
								</LinkContainer>
								<NavDropdown.Divider />
								<LinkContainer to="/support">
									<NavDropdown.Item>Support The Site</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/about/PrivacyPolicy">
									<NavDropdown.Item>Privacy Policy</NavDropdown.Item>
								</LinkContainer>
								<LinkContainer to="/about/Contact">
									<NavDropdown.Item>Contact</NavDropdown.Item>
								</LinkContainer>
							</>
						)}
					</NavDropdown>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};
